<template>
  <!--问答页面  -->
  <section class="questionspage-container"  >
    <home-nav :redirect="redirect">
          <div class="anchor-tab" slot="topbanner">
              <div class="tab-item" @click.prevent="scrollto('qs')">
                <img src="../assets/images/m_faq_questions_icon@3x.png" alt="常见问答">
                <div class="tab-text">常见问答</div>
              </div>
              <div class="tab-item" @click.prevent="scrollto('jc')">
                <img src="../assets/images/m_faq_articles_icon@3x.png" alt="文章教程">
                <div class="tab-text">文章教程</div>
              </div>
          </div>
      </home-nav>
    <div class="wrapper-container" ref="wrapper">
      <div class="wrapper">
          <section class="question-block" ref="qs">
            <p class="block-content">常见问答</p>
            <question-item :querstions="querstions"></question-item>
            <router-link to="/ask" class="question-button">查看更多问答</router-link>

          </section>
       
          <section class="question-block"  ref="jc">
            <p class="block-content">文章教程</p>
            <article-item :articleLists="artcles"></article-item>
            <router-link to="/article" class="question-button yellow">查看更多文章</router-link>
          </section>
          
      </div>
    </div>
    <Footer_></Footer_>
  </section>
</template>

<script>
import BScroll from 'better-scroll'
import ArticleItem from '@/components/modules/ArticleItem';
import Footer_ from './Footer.vue';
import QuestionItem from '@/components/modules/QuestionItem';
// import fastClick from 'fastclick'

// fastClick.attach(document.body)
export default {
  metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
  },
  data(){
    return{
      querstions:[
        {
          title:"我该选择哪个服务项目？",
          content:'比如您想恢复短信，请在果师兄App主页面菜单栏中选择【购买服务】，进入此页面后点击"短信"图标即可进入短信恢复流程，其他类似。'
        },
        {
          title:"我该选择哪个套餐？",
          content:"套餐有2种类型，分别是：预约排队，加急通道。您可以根据自身的数据的重要性，选择相应的服务套餐，因为数据丢失后往往需要第一时间找专业工程师恢复数据，否则数据可能损坏严重甚至找不回。"
        },
        {
          title:"预约人力费和数据恢复服务费有什么区别？",
          content:"恢复数据有两个重要步骤：数据恢复诊断分析和数据恢复，专业工程师对每一位预约的客户，都需要对设备和数据进行专业分析和判断，给出专业意见，这需要花费较高的人力成本；数据是无价的，数据能够被恢复是最好的，而如果工程师发现数据不能恢复将不会收取其他费用。因此，预约人力费是支付给果师兄工程师的数据分析诊断的人工费，而数据恢复服务费是支付成功恢复数据的功能费。"
        },
      ],
      artcles:[],
      floorScroll:"",
      redirect:true
    }
  },
  mounted(){
  },
  created(){
      this.getArticles();
    },
  watch:{
  
  },
  methods:{
    getArticles(){
      var vm = this;
      var data = {
        category_slug:'article',
        page:1,
        count:3
      }
      this.$store.dispatch("getArticles",data).then(function(res){
        const data = res.data;
        if(data.status == 'ok'){
            vm.artcles = data.posts;
        }

      })
    },
    scrollto(ref){
      let element = this.$refs[ref];
      let rootTop = document.documentElement || document.body;
      rootTop.scrollTop  = element.offsetTop;
      document.body.scrollTop = element.offsetTop;
      // Firefox
      document.documentElement.scrollTop = element.offsetTop;
      // Safari
      window.pageYOffset = element.offsetTop;
    },
 
  },
  components:{
    Footer_,
    ArticleItem,
    QuestionItem
  },
  
}
</script>

<style lang="scss" scoped>
  @import '../assets/css/base.scss';
  .wrapper{
    width: 100%;

  }
  .fixed_footer_wrapper{
    width:100%;
    flex-shrink: 0;
  }
  .wrapper-container{
    width: 100%;
    -webkit-overflow-scrolling: touch;

  }
  .questionspage-container{
    background:rgba(255,255,255,1);
    width: 100%;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;

    .question-button{
      width:pxtorem(300px);
      height:pxtorem(38px);
      background:linear-gradient(135deg,rgba(53,114,218,1) 0%,rgba(88,183,255,1) 100%);
      box-shadow:0px 8px 4px -6px rgba(49,98,250,0.5);
      border-radius:pxtorem(21px);
      color:#fff;
      display: block;
      text-align: center;
      line-height: pxtorem(38px);
      font-size:pxtorem(14px);
      margin:pxtorem(12px) auto 0;
      &.yellow{
        background:linear-gradient(135deg,rgba(247,107,28,1) 0%,rgba(250,217,97,1) 100%);
        box-shadow:0px 8px 4px -6px rgba(255,104,12,0.5);
      }
    }
    .anchor-tab{
        width:px2vw(355px);
        height:pxtorem(95px);
        margin:0 auto;
        background:rgba(255,255,255,0.95);
        box-shadow:0px 4px 5px -2px rgba(0,0,0,0.2);
        border-radius:pxtorem(6px);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:0 px2vw(75px);
        box-sizing: border-box;
    }
    .tab-item{
     text-align: center;
     font-size:pxtorem(13px);
     color:rgba(89,89,89,1);
     cursor: pointer;
      img{
        width:pxtorem(42px);
        margin-bottom:pxtorem(8px);
        cursor: pointer;

      }
    }
    .question-block{
      &:nth-last-child(1){
        padding-bottom:pxtorem(30px);
      }
      &+.question-block{
        margin-top:pxtorem(30px);
      }
      .block-content{
        font-size: pxtorem(18px);
        color:rgba(26,26,26,1);
        text-align: center;
        padding-bottom:pxtorem(20px);
      }
    }
  
  }

</style>



// WEBPACK FOOTER //
// src/components/QuestionsPage.vue